import React, { useContext } from "react";

import GlobalContext from "../../context/GlobalContext";

const Content = () => {
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
    const gContext = useContext(GlobalContext);

  return (
      <>
            <section id="whoweare" className="section p-relative gradient-img">
              <div className="container-fluid">
                  <div className="section-title text-center mb-5">

                      <h2>The right compliance professionals for <span className="text-theme">every step of certification</span></h2>
                      <h4 className="section-desc mt-4" style={{fontSize: '18px'}}>Find vetted experts who handle implementation, validation, certification, and training in one place.</h4>
                  </div>

                  <div className="row justify-content-center">
                      <div className="col-lg-3 col-md-6 mb-4">
                          <div className="card step-block p-relative who-weare-box">
                              <img src="images/compliance-experts-profiles.svg" alt="compliance-consultants" />
                              <div className="frame-data">
                                  <h6>Compliance consultants</h6>
                                  <p className="m-0">Experts who design and build your compliance program, from gap assessment and documentation to controls and audit readiness.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-4">
                          <div className="card step-block p-relative who-weare-box">
                              <img src="images/multiple-proposal.svg" alt="independent-auditors" />
                              <div className="frame-data">
                                  <h6>Independent auditors</h6>
                                  <p className="m-0">Qualified third-party auditors who review your implementation and validate that your controls meet the standard before formal certification.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-4">
                          <div className="card step-block p-relative who-weare-box">
                              <img src="images/project-tracking.svg" alt="certification-bodies" />
                              <div className="frame-data">
                                  <h6>Certification bodies</h6>
                                  <p className="m-0">Accredited certification bodies that perform the final audit and issue your official certification for standards such as ISO 9001 and ISO 27001.</p>
                              </div>
                          </div>
                      </div>

                      <div className="col-lg-3 col-md-6 mb-4">
                          <div className="card step-block p-relative who-weare-box">
                              <img src="images/get-hiried.svg" alt="training-providers" />
                              <div className="frame-data">
                                  <h6>Training providers</h6>
                                  <p className="m-0">Specialists who train your team on compliance requirements, internal audits, and how to maintain compliance after certification.</p>
                              </div>
                          </div>
                      </div>
                  </div>
                  </div>
          </section>
      </>
  );
};

export default Content;
